import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const fmtUsd = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtBtc = (n) => Number(n || 0).toFixed(8);
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const downloadReceipt = async (txId, admin = false) => {
  const { data } = await api.get(`${admin ? "/admin" : ""}/transactions/${txId}/receipt`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `bitwallet-receipt-${txId}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadCsv = async () => {
  const { data } = await api.get("/account/export", { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "bitwallet-transactions.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const MIN_FEE = 0.01;
export const feeOf = (usd) => (usd > 0 ? Math.max(MIN_FEE, Math.round(usd * 100 * 0.01) / 100) : 0);
